import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';
import { ContactInfo } from '../types/ContactInfo';
import { useCaseStatusLanguage } from '../../../../routes/CaseStatus/CaseStatusLanguageProvider';

type HelpCardProps = {
  contact: ContactInfo | null;
};

const HelpCard = ({ contact }: HelpCardProps) => {
  const { t } = useCaseStatusLanguage();
  return (
    <Paper elevation={1}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <PhoneIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
        <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>{t('NeedHelp')}</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ fontWeight: 700 }}>{contact?.phoneNumber}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <EmailIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant="body2">{contact?.email}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default HelpCard;